/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Report_Mispronunciation_DescInputs */

const en_dialog_report_mispronunciation_desc = /** @type {(inputs: Dialog_Report_Mispronunciation_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report the mispronunciation in this text.`)
};

const es_dialog_report_mispronunciation_desc = /** @type {(inputs: Dialog_Report_Mispronunciation_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporta el error de pronunciación en este texto.`)
};

/**
* | output |
* | --- |
* | "Report the mispronunciation in this text." |
*
* @param {Dialog_Report_Mispronunciation_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_report_mispronunciation_desc = /** @type {((inputs?: Dialog_Report_Mispronunciation_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Report_Mispronunciation_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_report_mispronunciation_desc(inputs)
	return en_dialog_report_mispronunciation_desc(inputs)
});